import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { FilterContainer } from 'src/components/FilterDrawer';
import {
  engagementListSearchConfig,
  ListSearchFilterOption,
} from 'src/sections/engagement/config/engagementListSearchConfig';

export interface EngagementFiltersListValues {
  workflowStatus: string;
  workflowScope: string;
  workflowStageName: string;
  assignedToMe: boolean;
}

type Props = {
  values: EngagementFiltersListValues;
  onChange: (key: keyof EngagementFiltersListValues, value: string | boolean) => void;
  scopeOptions?: ListSearchFilterOption[];
  stageOptions?: ListSearchFilterOption[];
  i18n?: (key: string, ns?: string) => string;
};

export default function EngagementFiltersList({
  values,
  onChange,
  scopeOptions = [],
  stageOptions = [],
  i18n = (k: string) => k,
}: Props) {
  const statusFilterConfig = engagementListSearchConfig.filters.find(
    (f) => f.key === 'workflowStatus'
  );
  const statusOptions = statusFilterConfig?.options ?? [
    { value: '', label: 'All' },
    { value: 'Open', label: 'Open' },
    { value: 'Close', label: 'Closed' },
  ];

  const scopeOptionsMerged = [
    { value: '', label: 'All' },
    ...scopeOptions.filter((o) => o.value !== ''),
  ];

  const stageOptionsMerged = [
    { value: '', label: 'All' },
    ...stageOptions.filter((o) => o.value !== ''),
  ];

  return (
    <Box py={3}>
      <Grid item xs={12}>
        <FilterContainer label={statusFilterConfig?.label ?? 'Status'}>
          <TextField
            select
            fullWidth
            size="small"
            value={values.workflowStatus}
            onChange={(e) => onChange('workflowStatus', e.target.value)}
          >
            {statusOptions.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterContainer>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <FilterContainer label="Scope">
          <TextField
            select
            fullWidth
            size="small"
            value={values.workflowScope}
            onChange={(e) => onChange('workflowScope', e.target.value)}
          >
            {scopeOptionsMerged.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterContainer>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <FilterContainer label="Stage">
          <TextField
            select
            fullWidth
            size="small"
            value={values.workflowStageName}
            onChange={(e) => onChange('workflowStageName', e.target.value)}
          >
            {stageOptionsMerged.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterContainer>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <Typography fontSize="1rem" fontWeight="bold" marginBottom={1.4}>
          Assigned to me
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.assignedToMe}
              onChange={(_, checked) => onChange('assignedToMe', checked)}
            />
          }
          label="View assigned to me"
        />
      </Grid>
    </Box>
  );
}
